import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { LogIn, UserPlus, X } from 'lucide-react';

interface GuestAuthBannerProps {
  onDismiss?: () => void;
  dismissible?: boolean;
  message?: string;
}

const GuestAuthBanner: React.FC<GuestAuthBannerProps> = ({
  onDismiss,
  dismissible = true,
  message
}) => {
  const { user } = useSelector((state: RootState) => state.auth);

  const isLoggedIn = user && user._id;

  if (isLoggedIn) {
    return null;
  }

  const defaultMessage = 'Sign up or log in to participate in discussions, create posts, and interact with the community!';

  return (
    <div className="bg-gradient-to-r from-green-50 to-emerald-50 border-l-4 border-green-500 p-4 mb-6 rounded-lg shadow-sm relative">
      {dismissible && onDismiss && (
        <button
          onClick={onDismiss}
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Dismiss"
        >
          <X className="h-5 w-5" />
        </button>
      )}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pr-8">
        <div className="flex-1">
          <h3 className="text-sm font-semibold text-gray-900 mb-1">Join Our Community</h3>
          <p className="text-sm text-gray-700">
            {message || defaultMessage}
          </p>
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          <Link
            to="/register"
            className="inline-flex items-center px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-lg hover:bg-green-700 transition-colors shadow-sm"
          >
            <UserPlus className="h-4 w-4 mr-2" />
            Sign Up
          </Link>
          <Link
            to="/login"
            className="inline-flex items-center px-4 py-2 bg-white text-green-600 text-sm font-medium rounded-lg border-2 border-green-600 hover:bg-green-50 transition-colors"
          >
            <LogIn className="h-4 w-4 mr-2" />
            Log In
          </Link>
        </div>
      </div>
    </div>
  );
};

export default GuestAuthBanner;
